module.exports = __webpack_public_path__ + "media/navi/photo_keyflow_1-54f13165.png";